import React from "react";
import { ArrowRight } from "lucide-react";
import "./Instrucciones.css";

const Instrucciones = ({
  instruccion,
  instruccionActual,
  totalInstrucciones,
  onSiguiente,
  // className = "",
}) => {
  return (
    <div className={`test-container`}>
      <h1 className="test-instrucciones">Instrucciones</h1>
      <div className="instruccion-card">
        {instruccion.img && <img src={instruccion.img} alt="Instrucción" />}
        {instruccion.leyenda && (
          <p className="leyenda-result">{instruccion.leyenda}</p>
        )}
        <p>{instruccion.texto}</p>
      </div>

      <button onClick={onSiguiente} className="btn-flecha">
        <ArrowRight size={24} />
      </button>

      <div className="dots-progreso">
        {Array.from({ length: totalInstrucciones }).map((_, index) => (
          <div
            key={index}
            className={`dot ${instruccionActual === index ? "active" : ""} ${
              instruccionActual > index ? "completado" : ""
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Instrucciones;